import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import "../../../assests/css/teachers/Teacherrequest.css";
import { useNavigate } from "react-router-dom";

const TeacherMyRequests = ({ onOpenChat }) => {
    const navigate = useNavigate();
    const { baseUrl } = useContext(AppContext);

    const [requests, setRequests] = useState([]);

    const fetchRequests = () => {

        const teacher = JSON.parse(localStorage.getItem("teacher"));

        axios
            .post(baseUrl + "/teacher/helpsupport/fetchTeacherRequests", {
                ngteacher_id: teacher.id,
            })
            .then((response) => {
                console.log(response.data.requests);
                if (response.data.success) {
                    setRequests(response.data.requests);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };
    useEffect(() => {
        fetchRequests();
    }, []);
    const handleOpenChat = (grRequest) => {
    if (grRequest.request_type === "notes_dispute") {
        navigate("/teacher-chat/" + grRequest.conversation_id);
    } else {
        navigate("/chat/" + grRequest.conversation_id);
    }
};


    return (
         <TeacherMasterLayout>
        <div className="tmr-requests-container">
            <div className="tmr-requests-header">
                <h2 className="tmr-requests-title">My Requests</h2>
            </div>

            <div className="tmr-requests-grid">
                {requests.map((req) => (
                    <div className="tmr-request-card" key={req.id}>
                        <div className="tmr-request-card-top">
                            <h3 className="tmr-request-name">{req.title}</h3>
                            <span
                                className={`tmr-status-badge ${req.status === "Pending"
                                    ? "tmr-status-pending"
                                    : "tmr-status-resolved"
                                    }`}
                            >
                                {req.status}
                            </span>
                        </div>

                        <div className="tmr-request-info">
                            <div className="tmr-request-info-row">
                                <span className="tmr-request-label">Issue:</span>
                                <span className="tmr-request-value">{req.issue}</span>
                            </div>
                            <div className="tmr-request-info-row">
                                <span className="tmr-request-label">Date:</span>
                                <span className="tmr-request-value">{req.date}</span>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="tmr-open-chat-btn"
                            onClick={() => handleOpenChat(req)}
                        >
                            Open Chat
                        </button>
                    </div>
                ))}
            </div>
        </div>
         </TeacherMasterLayout>
    );
   
};

export default TeacherMyRequests;